import { motion, useScroll, useTransform } from "framer-motion";
import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Icon from "@/components/ui/Icon/Icon";
import useMediaQuery from "@/hooks/useMediaQuery";

import CardVerticalSlider from "./CardVerticalSlider";
import ModalSwiper from "./ModalSwiper";
import { CardWidthModal } from "./VerticalCardSlideShow";

const Modal = dynamic(() => import("../ui/Modal/Modal"), { ssr: false });
const ModalContent = dynamic(() => import("../ui/Modal/ModalContent"), { ssr: false });

SwiperCore.use([Pagination]);

interface WallVerticalCardDataProp {
  arrayCards: CardWidthModal[];
}

const WallVerticalCards: FC<WallVerticalCardDataProp> = (cardsList) => {
  const t = useTranslations();
  const container = useRef<HTMLDivElement>(null);
  const [displayModal, setDisplayModal] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<CardWidthModal | null>(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start center", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0", "-50%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["0", "-210%"]);
  const y3 = useTransform(scrollYProgress, [0, 1], ["0", "-10%"]);
  const y4 = useTransform(scrollYProgress, [0, 1], ["0", "-230%"]);

  const openModal = useCallback((item: CardWidthModal) => {
    if (item) {
      setSelectedCard(item);
      setDisplayModal(true);
    }
  }, []);

  return (
    <div ref={container}>
      <div className="md:hidden">
        <Swiper
          breakpoints={{
            1024: {
              enabled: false,
            },
          }}
          className="w-full"
          slidesPerView={1.3}
          spaceBetween={10}
          centeredSlides={true}
          pagination={{ type: "progressbar" }}
        >
          {cardsList.arrayCards.map((item: CardWidthModal, index: number) => (
            <SwiperSlide key={index}>
              <button className="block w-full pt-m pb-[20px]" key={item.id} onClick={() => setSelectedCard(item)}>
                <CardVerticalSlider {...item} />
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="hidden md:grid md:grid-cols-4 gap-l px-l">
        {cardsList.arrayCards.map((item: CardWidthModal, index: number) => {
          let value;
          const i = index + 1;
          if ([1, 5, 9, 13].includes(i)) {
            value = y;
          } else if ([2, 6, 10, 14].includes(i)) {
            value = y2;
          } else if ([3, 7, 11, 15].includes(i)) {
            value = y3;
          } else if ([4, 8, 12, 16].includes(i)) {
            value = y4;
          }

          return (
            <motion.button style={{ y: value }} className="w-full" key={item.id + i} onClick={() => setSelectedCard(item)}>
              <CardVerticalSlider {...item} />
            </motion.button>
          );
        })}
      </div>

      <Modal open={selectedCard ? true : false} onClose={() => setSelectedCard(null)} className="!z-[60]">
        <ModalContent className="w-dvw h-dvh !rounded-none pb-l">
          <div className="flex justify-between items-center sticky top-0 pt-l bg-white z-[10]">
            <span className="text-m font-secondary uppercase opacity-0 md:opacity-100">{selectedCard?.modalTitle}</span>
            <button
              onClick={() => {
                setSelectedCard(null);
              }}
            >
              <Icon className="stroke-black" name="close" size="24" title={t("button.label.close")} />
            </button>
          </div>
          <ModalSwiper
            onClose={() => {
              setDisplayModal(false);
            }}
            card={selectedCard}
          />
        </ModalContent>
      </Modal>
    </div>
  );
};
export default WallVerticalCards;
